import styled from "@emotion/styled";
import { css } from "@emotion/react";
import {
	BaseModal,
	BaseModalProps,
	respondTo,
	Screen,
	ScreenProps,
	StyledBaseModal,
	StyledContainer,
	StyledScreen,
} from "@animech/ui";
import { FunctionComponent } from "react";

export const FooterButtons = styled.div``;
export const ScreenContent = styled.div``;
export const CustomScreenHeader = styled.h2``;
export const CustomModalHeader = styled.h2``;

const createRoot = (
	Component: FunctionComponent<BaseModalProps> | FunctionComponent<ScreenProps>,
) => styled(Component)`
	${({ theme }) => css`
		display: flex;
		flex-direction: column;
		padding: 1rem;
		font-size: ${theme.typography.fontSize.base} !important;
		font-weight: ${theme.typography.fontWeight.light} !important;

		${StyledBaseModal.Header} {
			padding: ${theme.dimensions.margin.large};
		}

		${StyledBaseModal.Title} {
			font-size: 2rem;
		}

		${ScreenContent} {
			display: flex;
			flex-direction: column;
			overflow: hidden;
			height: 100%;
			padding: 0 7% 7% 7%;

			${StyledContainer.Root} {
				padding: 0;
			}

			${FooterButtons} {
				margin-top: 1rem;
			}
		}

		${CustomModalHeader} {
			align-items: center;
			color: ${theme.colors.foregrounds[1]} !important;
			display: flex;
			font-size: ${theme.typography.fontSize.xxxxxLarge};
			font-weight: 300;
			gap: ${theme.dimensions.margin.small};
			margin-bottom: ${theme.dimensions.margin.large};
			line-height: 1;
		}

		${CustomScreenHeader} {
			text-align: center;
			font-size: 51px;
			line-height: 64px;
			font-weight: 300;
			margin: 5% 0 10%;
		}

		${StyledScreen.Header} {
			background: ${theme.colors.backgrounds[0].background};
			border: none;
		}

		${StyledBaseModal.Body} {
			padding: ${theme.dimensions.margin.large};
			display: flex;
			flex-direction: column;
		}

		${FooterButtons} {
			display: inline-flex;
			gap: ${theme.dimensions.margin.base};
			text-transform: uppercase;
		}

		${StyledBaseModal.Footer}, ${StyledScreen.Footer} {
			background-color: ${theme.colors.backgrounds[0].background} !important;
			padding: 0 ${theme.dimensions.margin.large}
				${theme.dimensions.margin.large};
			display: flex;
			align-items: center;

			&::before {
				display: none;
			}
		}

		${StyledBaseModal.Content} {
			min-width: 450px;

			${respondTo(theme, "mobile")} {
				min-width: unset;
				width: calc(100vw - 32px);
				max-height: 80vh;
				overflow-y: auto;
			}
		}
	`}
`;

export const ModalRoot = createRoot(BaseModal);
export const ScreenRoot = createRoot(Screen);
